import { Skeleton } from '@components/ui/skeleton'
import React from 'react'
import { Separator } from '@components/ui/separator'
const CartSkeleton = () => {
  return (
    <>
      <div className=" w-full flex flex-col gap-2 bg-white border p-4 rounded-sm">
        <Skeleton className="h-6 w-10/12 mb-4" />
        <div className="flex justify-between">
          <Skeleton className="h-6 w-3/5" />
          <Skeleton className="h-6 w-1/5" />
        </div>
        <div className="flex justify-between">
          <Skeleton className="h-6 w-2/5" />
          <Skeleton className="h-6 w-1/5" />
        </div>
        <div className="flex justify-between">
          <Skeleton className="h-6 w-3/5" />
          <Skeleton className="h-6 w-1/5" />
        </div>
        <div className="flex justify-between">
          <Skeleton className="h-6 w-3/12" />
          <Skeleton className="h-6 w-1/5" />
        </div>
        <Separator className="my-2" />
        <div className="flex justify-between">
          <Skeleton className="h-6 w-8/12" />
          <Skeleton className="h-6 w-1/5" />
        </div>
      </div>
    </>
  )
}

export default CartSkeleton
